module.exports = __webpack_public_path__ + "img/san-jose-hotel-2.aafb8796.jpg";